import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-file-download',
    templateUrl: './file-download.component.html',
    styleUrls: ['./file-download.component.sass'],
    standalone: false
})

export class FileDownloadComponent {

  @Input()
  file!: { name: string; link: string; };

}